export const BdmValidationLabels = {
    firstName: { english: 'First name', spanish: 'Nombre' },
    lastName: { english: 'Last name', spanish: 'Apellido' },
    dateOfBirth: { english: 'Date of birth', spanish: 'Fecha de nacimiento' },
    relationship: { english: 'Relationship', spanish: 'Relación' },
    phoneNumber: { english: 'Phone number', spanish: 'Número de teléfono' },
    guardianInformation: { english: 'Guardian information', spanish: 'Información del tutor' },
    ssnOrTaxId: { english: 'SSN or Tax ID', spanish: 'SSN o Tax ID' },
    streetAddress1: { english: 'Street address 1', spanish: 'Dirección 1' },
    streetAddress2: { english: 'Street address 2', spanish: 'Dirección 2' },
    country: { english: 'Country', spanish: 'País' },
    state: { english: 'State', spanish: 'Estado' },
    province: { english: 'Province', spanish: 'Provincia' },
    otherAddress: { english: 'Other address', spanish: 'Otra dirección' },
    city: { english: 'City', spanish: 'Ciudad' },
    charityName: { english: 'Charity name', spanish: 'Nombre de la organización benéfica' },
    contactName: { english: 'Contact name', spanish: 'Nombre de contacto' },
    trustName: { english: 'Trust name', spanish: 'Nombre del fideicomiso' },
    dateOfTrust: { english: 'Date of trust', spanish: 'Fecha del fideicomiso' },
    employeeId: { english: 'Employee ID', spanish: 'ID de empleado' },
    zipCode: { english: 'Zip code', spanish: 'Código postal' },
    signature: { english: 'Signature', spanish: 'Firma' },
};
